export default "__VITE_ASSET__DE28PB3K__"